<template>
  <div class="page-container">
    <div class="settings-form">
      <h2 class="page-title">短信账户管理</h2>

      <!-- 搜索区域 -->
      <div class="search-bar">
        <el-input v-model="searchForm.keyword" placeholder="请输入账户名称" clearable size="large"
          style="width: 300px; margin-right: 15px" @keyup.enter="handleSearch">
          <template #prefix>
            <el-icon>
              <Search />
            </el-icon>
          </template>
        </el-input>

        <el-select v-model="searchForm.provider" placeholder="服务商" clearable size="large"
          style="width: 150px; margin-right: 15px">
          <el-option label="阿里云" value="aliyun" />
          <el-option label="腾讯云" value="tencent" />
          <el-option label="掌骏云" value="zhangjun" />
          <el-option label="飞鸽云" value="feige" />
        </el-select>

        <el-select v-model="searchForm.status" placeholder="状态" clearable size="large"
          style="width: 120px; margin-right: 15px">
          <el-option label="启用" value="1" />
          <el-option label="禁用" value="0" />
        </el-select>

        <el-button type="primary" size="large" @click="handleSearch">
          <el-icon>
            <Search />
          </el-icon>
          搜索
        </el-button>

        <el-button type="success" size="large" @click="openAddDialog" style="float: right">
          <el-icon>
            <Plus />
          </el-icon>
          新增账户
        </el-button>
      </div>

      <!-- 账户列表 -->
      <el-table :data="accountList" stripe style="width: 100%; margin-top: 20px" v-loading="loading">
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column label="关联用户" width="150">
          <template #default="{ row }">
            <div class="user-info">
              <div class="user-nickname">{{ getUserInfo(row.user_id).nickname }}</div>
              <div class="user-phone">{{ getUserInfo(row.user_id).phone }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="account_name" label="账户名称" width="180" />
        <el-table-column prop="provider" label="服务商" width="120">
          <template #default="{ row }">
            <el-tag :type="getProviderTagType(row.provider)">
              {{ getProviderText(row.provider) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="is_enabled" label="状态" width="80" align="center">
          <template #default="{ row }">
            <el-switch v-model="row.is_enabled" :active-value="1" :inactive-value="0"
              @change="handleStatusChange(row)" />
          </template>
        </el-table-column>
        <el-table-column prop="notes" label="备注" />
        <el-table-column prop="last_sync_time" label="最后同步" width="180" />
        <el-table-column prop="create_time" label="创建时间" width="180" />
        <el-table-column prop="update_time" label="更新时间" width="180" />

        <el-table-column label="操作" width="420" fixed="right">
          <template #default="scope">
            <div class="action-buttons">
              <div class="button-row">
                <el-button type="info" size="small" @click="openDetailDialog(scope.row)">
                  <el-icon>
                    <View />
                  </el-icon>详情
                </el-button>
                <el-button type="warning" size="small" @click="openSyncDialog(scope.row)">
                  <el-icon>
                    <Refresh />
                  </el-icon>同步
                </el-button>
                <el-button type="primary" size="small" @click="openSignDialog(scope.row)">
                  <el-icon>
                    <EditPen />
                  </el-icon>签名
                </el-button>
                <el-button type="primary" size="small" @click="openTemplateDialog(scope.row)">
                  <el-icon>
                    <Document />
                  </el-icon>模板
                </el-button>
              </div>
              <div class="button-row">
                <el-button type="primary" size="small" @click="openTestDialog(scope.row)">
                  <el-icon>
                    <Promotion />
                  </el-icon>测试
                </el-button>
                <el-button type="success" size="small" @click="openRecordDialog(scope.row)">
                  <el-icon>
                    <List />
                  </el-icon>记录
                </el-button>
                <el-button type="success" size="small" @click="openEditDialog(scope.row)">
                  <el-icon>
                    <Edit />
                  </el-icon>编辑
                </el-button>
                <el-button type="danger" size="small" @click="handleDelete(scope.row.id)">
                  <el-icon>
                    <Delete />
                  </el-icon>删除
                </el-button>
              </div>
            </div>
          </template>
        </el-table-column>

      </el-table>

      <!-- 分页组件 -->
      <div class="pagination-container">
        <el-pagination v-model:current-page="pagination.page" v-model:page-size="pagination.pageSize"
          :total="pagination.total" :page-sizes="[10, 20, 30, 50]" layout="total, sizes, prev, pager, next, jumper"
          @size-change="fetchAccountList" @current-change="fetchAccountList" />
      </div>
    </div>

    <!-- 新增飞鸽云状态报告对话框 -->
    <el-dialog v-model="feigeReportDialogVisible" title="飞鸽云状态报告" width="90%" top="5vh">
      <div v-loading="feigeReportLoading">
        <div class="toolbar" style="margin-bottom: 16px;">
          <el-button type="primary" @click="fetchFeigeReport">
            <el-icon>
              <Refresh />
            </el-icon>
            刷新报告
          </el-button>
          <el-select v-model="reportCount" style="width: 120px; margin-left: 10px">
            <el-option label="10条" value="10" />
            <el-option label="20条" value="20" />
            <el-option label="50条" value="50" />
            <el-option label="100条" value="100" />
          </el-select>
        </div>

        <el-table :data="feigeReportData" stripe style="width: 100%">
          <el-table-column prop="msg_no" label="回执编号" width="180" />
          <el-table-column prop="mobile" label="手机号码" width="120" />
          <el-table-column prop="status" label="状态码" width="120">
            <template #default="{ row }">
              <el-tag :type="getReportStatusTagType(row.status)">
                {{ row.status }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="status_desc" label="状态描述" />
          <el-table-column prop="time" label="时间" width="180">
            <template #default="{ row }">
              {{ formatTimestamp(row.time) }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <!-- 新增飞鸽云上行对话框 -->
    <el-dialog v-model="feigeMoDialogVisible" title="飞鸽云上行信息" width="90%" top="5vh">
      <div v-loading="feigeMoLoading">
        <div class="toolbar" style="margin-bottom: 16px;">
          <el-button type="primary" @click="fetchFeigeMo">
            <el-icon>
              <Refresh />
            </el-icon>
            刷新上行
          </el-button>
          <el-select v-model="moCount" style="width: 120px; margin-left: 10px">
            <el-option label="10条" value="10" />
            <el-option label="20条" value="20" />
            <el-option label="50条" value="50" />
            <el-option label="100条" value="100" />
          </el-select>
        </div>

        <el-table :data="feigeMoData" stripe style="width: 100%">
          <el-table-column prop="msg_no" label="批次号" width="180" />
          <el-table-column prop="mobile" label="手机号码" width="120" />
          <el-table-column prop="content" label="上行内容" />
          <el-table-column prop="sms_content" label="原短信内容" />
          <el-table-column prop="ext_no" label="扩展号码" width="100" />
          <el-table-column prop="time" label="时间" width="180">
            <template #default="{ row }">
              {{ formatTimestamp(row.time) }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <!-- 新增/编辑对话框 -->
    <el-dialog v-model="dialogVisible" :title="dialogTitle" width="800px" :close-on-click-modal="false">
      <el-form ref="accountForm" :model="accountForm" label-width="120px" :rules="formRules">
        <el-form-item label="账户名称" prop="account_name">
          <el-input v-model="accountForm.account_name" placeholder="请输入账户名称" size="large" />
        </el-form-item>

        <el-form-item label="服务商" prop="provider">
          <el-select v-model="accountForm.provider" placeholder="请选择服务商" size="large" style="width: 100%"
            @change="handleProviderChange">
            <el-option label="阿里云短信" value="aliyun" />
            <el-option label="腾讯云短信" value="tencent" />
            <el-option label="掌骏云短信" value="zhangjun" />
            <el-option label="飞鸽云短信" value="feige" />
          </el-select>
        </el-form-item>

        <el-form-item label="启用状态">
          <el-switch v-model="accountForm.is_enabled" :active-value="1" :inactive-value="0" />
        </el-form-item>

        <!-- 阿里云配置 -->
        <div v-if="accountForm.provider === 'aliyun'">
          <el-divider content-position="left">阿里云配置</el-divider>

          <el-form-item label="AccessKeyId" prop="aliyun_access_key_id">
            <el-input v-model="accountForm.aliyun_access_key_id" placeholder="请输入AccessKeyId" size="large" />
          </el-form-item>

          <el-form-item label="AccessKeySecret" prop="aliyun_access_key_secret">
            <el-input v-model="accountForm.aliyun_access_key_secret" type="password" placeholder="请输入AccessKeySecret"
              size="large" show-password />
          </el-form-item>

          <el-form-item label="Endpoint">
            <el-input v-model="accountForm.aliyun_endpoint" placeholder="请输入Endpoint" size="large" />
          </el-form-item>

          <el-form-item label="区域">
            <el-input v-model="accountForm.aliyun_region" placeholder="请输入区域" size="large" />
          </el-form-item>
        </div>

        <!-- 腾讯云配置 -->
        <div v-if="accountForm.provider === 'tencent'">
          <el-divider content-position="left">腾讯云配置</el-divider>

          <el-form-item label="SecretId" prop="tencent_secret_id">
            <el-input v-model="accountForm.tencent_secret_id" placeholder="请输入SecretId" size="large" />
          </el-form-item>

          <el-form-item label="SecretKey" prop="tencent_secret_key">
            <el-input v-model="accountForm.tencent_secret_key" type="password" placeholder="请输入SecretKey" size="large"
              show-password />
          </el-form-item>

          <el-form-item label="AppId" prop="tencent_app_id">
            <el-input v-model="accountForm.tencent_app_id" placeholder="请输入AppId" size="large" />
          </el-form-item>

          <el-form-item label="区域">
            <el-input v-model="accountForm.tencent_region" placeholder="请输入区域" size="large" />
          </el-form-item>
        </div>

        <!-- 掌骏云配置 -->
        <div v-if="accountForm.provider === 'zhangjun'">
          <el-divider content-position="left">掌骏云配置</el-divider>

          <el-form-item label="用户名" prop="zhangjun_username">
            <el-input v-model="accountForm.zhangjun_username" placeholder="请输入用户名" size="large" />
          </el-form-item>

          <el-form-item label="密码" prop="zhangjun_password">
            <el-input v-model="accountForm.zhangjun_password" type="password" placeholder="请输入密码" size="large"
              show-password />
          </el-form-item>

          <el-form-item label="接口地址">
            <el-input v-model="accountForm.zhangjun_endpoint" placeholder="请输入接口地址" size="large" />
          </el-form-item>
        </div>

        <!-- 飞鸽云配置 -->
        <div v-if="accountForm.provider === 'feige'">
          <el-divider content-position="left">飞鸽云配置</el-divider>

          <el-form-item label="API Key" prop="feige_api_key">
            <el-input v-model="accountForm.feige_api_key" placeholder="请输入API Key" size="large" />
            <div class="form-tips">在飞鸽云平台获取的API Key</div>
          </el-form-item>

          <el-form-item label="Secret" prop="feige_secret">
            <el-input v-model="accountForm.feige_secret" type="password" placeholder="请输入Secret" size="large"
              show-password />
            <div class="form-tips">在飞鸽云平台获取的Secret，请妥善保管</div>
          </el-form-item>
          <el-form-item label="接口地址">
            <el-input v-model="accountForm.feige_endpoint" placeholder="请输入接口地址" size="large" />
            <div class="form-tips">飞鸽云接口地址，一般使用默认值</div>
          </el-form-item>
        </div>

        <el-form-item label="备注信息">
          <el-input v-model="accountForm.notes" placeholder="请输入备注信息" type="textarea" :rows="3" />
        </el-form-item>
      </el-form>

      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitAccountForm">确认</el-button>
      </template>
    </el-dialog>

    <!-- 详情对话框 -->
    <el-dialog v-model="detailDialogVisible" title="账户详情" width="800px">
      <el-descriptions :column="2" border v-if="currentAccount">
        <el-descriptions-item label="账户ID">{{ currentAccount.id }}</el-descriptions-item>
        <el-descriptions-item label="账户名称">{{ currentAccount.account_name }}</el-descriptions-item>
        <el-descriptions-item label="服务商">
          <el-tag :type="getProviderTagType(currentAccount.provider)">
            {{ getProviderText(currentAccount.provider) }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="状态">
          <el-tag :type="currentAccount.is_enabled ? 'success' : 'danger'">
            {{ currentAccount.is_enabled ? '启用' : '禁用' }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="最后同步">{{ currentAccount.last_sync_time || '从未同步' }}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ currentAccount.create_time }}</el-descriptions-item>
        <el-descriptions-item label="更新时间">{{ currentAccount.update_time }}</el-descriptions-item>
        <el-descriptions-item label="备注" :span="2">{{ currentAccount.notes || '无' }}</el-descriptions-item>

        <!-- 阿里云详情 -->
        <template v-if="currentAccount.provider === 'aliyun'">
          <el-descriptions-item label="AccessKeyId">{{ currentAccount.aliyun_access_key_id }}</el-descriptions-item>
          <el-descriptions-item label="AccessKeySecret">
            {{ currentAccount.aliyun_access_key_secret_masked }}
          </el-descriptions-item>
          <el-descriptions-item label="Endpoint">{{ currentAccount.aliyun_endpoint }}</el-descriptions-item>
          <el-descriptions-item label="区域">{{ currentAccount.aliyun_region }}</el-descriptions-item>
        </template>

        <!-- 腾讯云详情 -->
        <template v-if="currentAccount.provider === 'tencent'">
          <el-descriptions-item label="SecretId">{{ currentAccount.tencent_secret_id }}</el-descriptions-item>
          <el-descriptions-item label="SecretKey">
            {{ currentAccount.tencent_secret_key_masked }}
          </el-descriptions-item>
          <el-descriptions-item label="AppId">{{ currentAccount.tencent_app_id }}</el-descriptions-item>
          <el-descriptions-item label="区域">{{ currentAccount.tencent_region }}</el-descriptions-item>
        </template>

        <!-- 掌骏云详情 -->
        <template v-if="currentAccount.provider === 'zhangjun'">
          <el-descriptions-item label="用户名">{{ currentAccount.zhangjun_username }}</el-descriptions-item>
          <el-descriptions-item label="密码">
            {{ currentAccount.zhangjun_password_masked }}
          </el-descriptions-item>
          <el-descriptions-item label="接口地址">{{ currentAccount.zhangjun_endpoint }}</el-descriptions-item>
        </template>

        <!-- 飞鸽云详情 -->
        <template v-if="currentAccount.provider === 'feige'">
          <el-descriptions-item label="API Key">{{ currentAccount.feige_api_key }}</el-descriptions-item>
          <el-descriptions-item label="Secret">
            {{ currentAccount.feige_secret_masked }}
          </el-descriptions-item>
          <el-descriptions-item label="接口地址">{{ currentAccount.feige_endpoint }}</el-descriptions-item>
        </template>
      </el-descriptions>
    </el-dialog>

    <!-- 同步对话框 -->
    <el-dialog v-model="syncDialogVisible" :title="syncDialogTitle" width="600px">
      <div v-loading="syncLoading">
        <el-alert type="info" show-icon :closable="false" style="margin-bottom: 20px;">
          同步将从短信服务商获取最新的签名和模板信息
        </el-alert>

        <div class="sync-actions">
          <el-button type="primary" @click="handleSyncSigns" :loading="syncingSigns">
            <el-icon>
              <Refresh />
            </el-icon>
            同步签名
          </el-button>

          <el-button type="success" @click="handleSyncTemplates" :loading="syncingTemplates">
            <el-icon>
              <Refresh />
            </el-icon>
            同步模板
          </el-button>
        </div>

        <!-- 同步结果 -->
        <div v-if="syncResult" class="sync-result">
          <el-alert :type="syncResult.success ? 'success' : 'error'" :title="syncResult.message" show-icon />
          <div v-if="syncResult.synced_count !== undefined" class="sync-count">
            同步数量: {{ syncResult.synced_count }}
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 测试对话框 -->
    <el-dialog v-model="testDialogVisible" title="测试短信发送" width="700px">
      <el-form ref="testForm" :model="testForm" label-width="120px">
        <el-form-item label="测试账户">
          <el-input :value="currentAccount?.account_name" disabled />
        </el-form-item>

        <!-- 添加签名选择 -->
        <el-form-item label="选择签名" prop="sign_name">
          <el-select v-model="testForm.sign_name" placeholder="请选择签名" style="width: 100%" :loading="signsLoading">
            <el-option v-for="sign in signs" :key="sign.id" :label="sign.sign_name" :value="sign.sign_name" />
          </el-select>
        </el-form-item>

        <!-- 在测试对话框中添加手机号输入框 -->
        <el-form-item label="手机号码" prop="phone_number"
          :rules="[{ required: true, message: '请输入手机号码', trigger: 'blur' }]">
          <el-input v-model="testForm.phone_number" placeholder="请输入测试手机号码" />
        </el-form-item>

        <el-form-item label="测试类型">
          <el-radio-group v-model="testForm.test_type" @change="handleTestTypeChange">
            <el-radio label="template">模板测试</el-radio>
            <el-radio label="content">内容测试</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- 模板测试 -->
        <div v-if="testForm.test_type === 'template'">
          <el-form-item label="选择模板" prop="template_id">
            <el-select v-model="testForm.template_id" placeholder="请选择模板" style="width: 100%"
              @change="handleTemplateChange" :loading="templatesLoading">
              <el-option v-for="template in templates" :key="template.id" :label="template.template_name"
                :value="template.id" />
            </el-select>
          </el-form-item>

          <el-form-item label="模板内容">
            <el-input :value="selectedTemplate?.template_content" type="textarea" :rows="3" readonly />
          </el-form-item>

          <el-form-item label="模板变量" v-if="templateVariables.length > 0">
            <div class="variable-list">
              <div v-for="variable in templateVariables" :key="variable" class="variable-item">
                <span class="variable-name">{{ variable }}:</span>
                <el-input v-model="testForm.template_variables[variable]" :placeholder="`请输入${variable}的值`"
                  style="width: 200px; margin-left: 10px" />
              </div>
            </div>
          </el-form-item>
        </div>

        <div v-else>
          <el-form-item label="短信内容" prop="content">
            <el-input v-model="testForm.content" type="textarea" :rows="4"
              placeholder="请输入短信内容，需包含签名，如：【公司名称】您的验证码是123456" />
          </el-form-item>

          <el-form-item label="预览内容" v-if="previewContent">
            <el-alert type="info" :title="previewContent" show-icon :closable="false" />
          </el-form-item>
        </div>
      </el-form>

      <template #footer>
        <el-button @click="testDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSendTest" :loading="sendingTest">发送测试</el-button>
      </template>
    </el-dialog>

    <!-- 测试记录对话框 -->
    <el-dialog v-model="recordDialogVisible" title="测试记录" width="90%" top="5vh">
      <TestRecordView v-if="recordDialogVisible" :account-id="currentAccountId" />
    </el-dialog>

    <!-- 新增签名对话框 -->
    <el-dialog v-model="addSignDialogVisible" title="新增签名" width="500px">
      <el-form ref="signForm" :model="signForm" label-width="100px">
        <el-form-item label="账户名称">
          <el-input :value="currentAccount?.account_name" disabled />
        </el-form-item>
        <el-form-item label="签名名称" prop="sign_name" :rules="[{ required: true, message: '请输入签名名称', trigger: 'blur' }]">
          <el-input v-model="signForm.sign_name" placeholder="请输入签名名称" />
          <div class="form-tips">例如：公司名称、品牌名称等</div>
        </el-form-item>

        <!-- 服务商签名ID -->
        <el-form-item label="签名ID"
          v-if="currentAccount?.provider === 'feige' || currentAccount?.provider === 'tencent'">
          <el-input v-model="signForm.provider_sign_id" placeholder="请输入服务商签名ID" />
          <div class="form-tips" v-if="currentAccount?.provider === 'feige'">在飞鸽云平台获取的签名ID</div>
          <div class="form-tips" v-if="currentAccount?.provider === 'tencent'">在腾讯云平台获取的签名ID</div>
        </el-form-item>

        <el-form-item label="备注">
          <el-input v-model="signForm.notes" type="textarea" :rows="3" placeholder="请输入备注信息（可选）" />
        </el-form-item>
      </el-form>

      <template #footer>
        <el-button @click="addSignDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleAddSign" :loading="addingSign">确认添加</el-button>
      </template>
    </el-dialog>

    <!-- 新增模板对话框 -->
    <el-dialog v-model="addTemplateDialogVisible" title="新增模板" width="600px">
      <el-form ref="templateForm" :model="templateForm" label-width="120px">
        <el-form-item label="账户名称">
          <el-input :value="currentAccount?.account_name" disabled />
        </el-form-item>
        <el-form-item label="模板名称" prop="template_name"
          :rules="[{ required: true, message: '请输入模板名称', trigger: 'blur' }]">
          <el-input v-model="templateForm.template_name" placeholder="请输入模板名称" />
        </el-form-item>

        <!-- 服务商模板ID -->
        <el-form-item label="模板ID"
          v-if="currentAccount?.provider === 'feige' || currentAccount?.provider === 'tencent'">
          <el-input v-model="templateForm.provider_template_id" placeholder="请输入服务商模板ID" />
          <div class="form-tips" v-if="currentAccount?.provider === 'feige'">在飞鸽云平台获取的模板ID</div>
          <div class="form-tips" v-if="currentAccount?.provider === 'tencent'">在腾讯云平台获取的模板ID</div>
        </el-form-item>

        <el-form-item label="模板CODE">
          <el-input v-model="templateForm.template_code" placeholder="请输入模板CODE（可选）" />
        </el-form-item>

        <el-form-item label="模板类型">
          <el-select v-model="templateForm.template_type" placeholder="请选择模板类型" style="width: 100%">
            <el-option label="验证码短信" value="验证码短信" />
            <el-option label="短信通知" value="短信通知" />
            <el-option label="推广短信" value="推广短信" />
            <el-option label="国际短信" value="国际短信" />
          </el-select>
        </el-form-item>

        <el-form-item label="模板内容" prop="template_content"
          :rules="[{ required: true, message: '请输入模板内容', trigger: 'blur' }]">
          <el-input v-model="templateForm.template_content" type="textarea" :rows="4"
            placeholder="请输入模板内容，支持变量如：${code}、{name}、{%time%}" />
          <div class="form-tips">支持变量格式：$$变量名、${变量名}、{变量名}、{%变量名%}</div>
        </el-form-item>

        <el-form-item label="解析的变量" v-if="parsedVariables.length > 0">
          <div class="variable-tags">
            <el-tag v-for="variable in parsedVariables" :key="variable" type="info"
              style="margin-right: 8px; margin-bottom: 8px;">
              {{ variable }}
            </el-tag>
          </div>
          <div class="form-tips">系统自动从模板内容中解析出的变量</div>
        </el-form-item>
      </el-form>

      <template #footer>
        <el-button @click="addTemplateDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleAddTemplate" :loading="addingTemplate">确认添加</el-button>
      </template>
    </el-dialog>

    <!-- 签名列表对话框 -->
    <el-dialog v-model="signDialogVisible" :title="signDialogTitle" width="80%" top="5vh">
      <div v-loading="signsLoading">
        <!-- 操作工具栏 -->
        <div class="toolbar" style="margin-bottom: 16px;">
          <el-button type="primary" @click="openAddSignDialog"
            v-if="currentAccount?.provider === 'tencent' || currentAccount?.provider === 'feige'">
            <el-icon>
              <Plus />
            </el-icon>
            新增签名
          </el-button>
          <el-button @click="fetchSigns(currentAccount.id)">
            <el-icon>
              <Refresh />
            </el-icon>
            刷新
          </el-button>
        </div>

        <el-table :data="signs" stripe style="width: 100%">
          <el-table-column prop="id" label="ID" width="80" />
          <el-table-column prop="sign_name" label="签名名称" width="200" />

          <!-- 服务商签名ID显示 -->
          <el-table-column prop="provider_sign_id" label="签名ID" width="120"
            v-if="currentAccount?.provider === 'feige' || currentAccount?.provider === 'tencent'">
            <template #default="{ row }">
              {{ row.provider_sign_id || '-' }}
            </template>
          </el-table-column>

          <el-table-column prop="audit_status" label="审核状态" width="120">
            <template #default="{ row }">
              <el-tag :type="getAuditStatusTagType(row.audit_status)">
                {{ getAuditStatusText(row.audit_status) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="audit_reason" label="审核原因" />
          <el-table-column prop="sign_source" label="来源" width="100">
            <template #default="{ row }">
              <el-tag :type="row.sign_source === 'sync' ? 'success' : 'primary'">
                {{ row.sign_source === 'sync' ? '同步' : '手动' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="create_date" label="创建时间" width="180" />
          <el-table-column prop="update_time" label="更新时间" width="180" />
          <el-table-column label="操作" width="120"
            v-if="currentAccount?.provider === 'tencent' || currentAccount?.provider === 'feige'">
            <template #default="{ row }">
              <el-button type="danger" size="small" @click="handleDeleteSign(row.id)">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <!-- 模板列表对话框 -->
    <el-dialog v-model="templateDialogVisible" :title="templateDialogTitle" width="90%" top="5vh">
      <div v-loading="templatesLoading">
        <!-- 操作工具栏 -->
        <div class="toolbar" style="margin-bottom: 16px;">
          <el-button type="primary" @click="openAddTemplateDialog"
            v-if="currentAccount?.provider === 'tencent' || currentAccount?.provider === 'feige'">
            <el-icon>
              <Plus />
            </el-icon>
            新增模板
          </el-button>
          <el-button @click="fetchTemplates(currentAccount.id)">
            <el-icon>
              <Refresh />
            </el-icon>
            刷新
          </el-button>
        </div>

        <el-table :data="templates" stripe style="width: 100%">
          <el-table-column prop="id" label="ID" width="80" />
          <el-table-column prop="template_code" label="模板CODE" width="150" />
          <el-table-column prop="provider_template_id" label="服务商模板ID" width="150" />
          <el-table-column prop="template_name" label="模板名称" width="180" />
          <el-table-column prop="template_content" label="模板内容" min-width="300">
            <template #default="{ row }">
              <div class="content-preview" :title="row.template_content">
                {{ row.template_content }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="template_type" label="模板类型" width="120" />
          <el-table-column prop="audit_status" label="审核状态" width="120">
            <template #default="{ row }">
              <el-tag :type="getAuditStatusTagType(row.audit_status)">
                {{ getAuditStatusText(row.audit_status) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="create_date" label="创建时间" width="180" />
          <el-table-column prop="update_time" label="更新时间" width="180" />
          <el-table-column label="操作" width="120"
            v-if="currentAccount?.provider === 'tencent' || currentAccount?.provider === 'feige'">
            <template #default="{ row }">
              <el-button type="danger" size="small" @click="handleDeleteTemplate(row.id)">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import axios from 'axios';
import config from '@/config.js';
import Cookies from 'js-cookie';
import {
  Search, Plus, Edit, Delete, View, Refresh, Promotion,
  EditPen, Document, List // 添加新的图标
} from '@element-plus/icons-vue'
import TestRecordView from '@/components/TestRecordView.vue'

export default {
  name: 'SmsAccount',
  components: { Search, Plus, Edit, Delete, View, Refresh, Promotion, TestRecordView, EditPen, Document, List },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      detailDialogVisible: false,
      syncDialogVisible: false,
      testDialogVisible: false,
      recordDialogVisible: false,
      syncLoading: false,


      // 飞鸽云报告相关
      feigeReportDialogVisible: false,
      feigeReportLoading: false,
      feigeReportData: [],
      reportCount: '10',

      // 飞鸽云上行相关
      feigeMoDialogVisible: false,
      feigeMoLoading: false,
      feigeMoData: [],
      moCount: '10',

      // 新增签名相关
      addSignDialogVisible: false,
      addingSign: false,
      signForm: {
        sign_name: '',
        provider_sign_id: '',
        notes: ''
      },

      // 新增模板相关
      addTemplateDialogVisible: false,
      addingTemplate: false,
      templateForm: {
        template_name: '',
        template_code: '',
        provider_template_id: '',
        template_type: '验证码短信',
        template_content: ''
      },
      parsedVariables: [],

      sendingTest: false,
      syncingSigns: false,
      syncingTemplates: false,

      signDialogVisible: false,
      templateDialogVisible: false,
      signs: [],
      templates: [],
      signsLoading: false,
      templatesLoading: false,
      signDialogTitle: '签名列表',
      templateDialogTitle: '模板列表',

      dialogTitle: '新增账户',
      syncDialogTitle: '同步数据',
      isEditMode: false,
      currentAccount: null,
      currentAccountId: null,

      searchForm: {
        keyword: '',
        provider: '',
        status: ''
      },

      accountForm: {
        id: null,
        account_name: '',
        provider: 'aliyun',
        is_enabled: 1,
        // 阿里云
        aliyun_access_key_id: '',
        aliyun_access_key_secret: '',
        aliyun_endpoint: 'dysmsapi.aliyuncs.com',
        aliyun_region: 'cn-hangzhou',
        // 腾讯云
        tencent_secret_id: '',
        tencent_secret_key: '',
        tencent_app_id: '',
        tencent_region: 'ap-guangzhou',
        // 掌骏云
        zhangjun_username: '',
        zhangjun_password: '',
        zhangjun_endpoint: 'http://47.106.170.137:8001/sms',
        // 飞鸽云
        feige_api_key: '',
        feige_secret: '',
        feige_endpoint: 'https://api.4321.sh',
        notes: ''
      },

      testForm: {
        test_type: 'template',
        template_id: null,
        sign_name: '', // 添加签名选择
        template_variables: {},
        content: '',
        phone_number: ''
      },

      formRules: {
        account_name: [
          { required: true, message: '请输入账户名称', trigger: 'blur' }
        ],
        provider: [
          { required: true, message: '请选择服务商', trigger: 'change' }
        ],
        aliyun_access_key_id: [
          { required: true, message: '请输入AccessKeyId', trigger: 'blur' }
        ],
        aliyun_access_key_secret: [
          { required: true, message: '请输入AccessKeySecret', trigger: 'blur' }
        ],
        tencent_secret_id: [
          { required: true, message: '请输入SecretId', trigger: 'blur' }
        ],
        tencent_secret_key: [
          { required: true, message: '请输入SecretKey', trigger: 'blur' }
        ],
        tencent_app_id: [
          { required: true, message: '请输入AppId', trigger: 'blur' }
        ],
        zhangjun_username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        zhangjun_password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        feige_api_key: [
          { required: true, message: '请输入API Key', trigger: 'blur' }
        ],
        feige_secret: [
          { required: true, message: '请输入Secret', trigger: 'blur' }
        ]
      },

      accountList: [],
      selectedTemplate: null,
      templateVariables: [],
      syncResult: null,
      previewContent: '',
      userList: [], // 用户列表
      userMap: {},  // 用户ID映射
      userLoading: false,
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  computed: {
    userInfo() {
      return JSON.parse(Cookies.get('user_info') || '{}')
    }
  },
  watch: {
    'testForm.template_variables': {
      handler() {
        this.updatePreviewContent()
      },
      deep: true
    },
    'testForm.content'() {
      this.updatePreviewContent()
    },
    'templateForm.template_content'(newContent) {
      this.parseTemplateVariables(newContent)
    }
  },
  mounted() {
    this.fetchAccountList()
    this.fetchUserList()
  },
  methods: {
    // 获取账户列表
    async fetchAccountList() {
      this.loading = true
      try {
        const params = {
          action: 'list',
          store_id: this.userInfo.id,
          page: this.pagination.page,
          page_size: this.pagination.pageSize
        }

        // 添加搜索条件
        if (this.searchForm.keyword) {
          params.keyword = this.searchForm.keyword
        }
        if (this.searchForm.provider) {
          params.provider = this.searchForm.provider
        }
        if (this.searchForm.status !== '') {
          params.status = this.searchForm.status
        }

        const { data } = await axios.post(
          `${config.BASE_URL}/shop/api/sms_account.php`,
          params
        )

        if (data.data) {
          this.accountList = data.data
          this.pagination.total = data.pagination?.total || data.data.length
        }
      } catch (error) {
        this.$message.error('获取账户列表失败')
        console.error('获取账户列表错误:', error)
      } finally {
        this.loading = false
      }
    },


    // 获取用户列表
    async fetchUserList() {
      this.userLoading = true
      try {
        const response = await axios.post(
          `${config.BASE_URL}/shop/api/associated_user.php`,
          {
            action: 'get_users',
            store_id: this.userInfo.id
          }
        )

        if (response.data.data) {
          this.userList = response.data.data
          // 构建用户映射
          this.userMap = {}
          response.data.data.forEach(user => {
            this.userMap[user.id] = user
          })
        }
      } catch (error) {
        console.error('获取用户列表错误:', error)
      } finally {
        this.userLoading = false
      }
    },

    // 根据user_id获取用户信息
    getUserInfo(userId) {
      const user = this.userMap[userId]
      if (user) {
        return {
          nickname: user.nickname,
          phone: user.phone,
          avatar: user.avatar
        }
      }
      return {
        nickname: '管理员',
        phone: '',
        avatar: ''
      }
    },
    // 获取审核状态显示文本
    getAuditStatusText(status) {
      const statusMap = {
        'AUDIT_STATE_PASS': '审核通过',
        'AUDIT_STATE_INIT': '审核中',
        'AUDIT_STATE_NOT_PASS': '审核未通过',
        'AUDIT_STATE_CANCEL': '取消审核'
      }
      return statusMap[status] || status
    },

    // 获取审核状态标签类型
    getAuditStatusTagType(status) {
      const typeMap = {
        'AUDIT_STATE_PASS': 'success',
        'AUDIT_STATE_INIT': 'warning',
        'AUDIT_STATE_NOT_PASS': 'danger',
        'AUDIT_STATE_CANCEL': 'info'
      }
      return typeMap[status] || 'info'
    },

    // 打开签名对话框
    async openSignDialog(row) {
      this.currentAccount = row
      this.signDialogTitle = `签名列表 - ${row.account_name}`
      this.signDialogVisible = true
      await this.fetchSigns(row.id)
    },

    // 打开模板对话框
    async openTemplateDialog(row) {
      this.currentAccount = row
      this.templateDialogTitle = `模板列表 - ${row.account_name}`
      this.templateDialogVisible = true
      await this.fetchTemplates(row.id)
    },

    // 打开新增签名对话框
    openAddSignDialog() {
      this.signForm = {
        sign_name: '',
        provider_sign_id: '',
        notes: ''
      }
      this.addSignDialogVisible = true
    },

    // 打开新增模板对话框
    openAddTemplateDialog() {
      this.templateForm = {
        template_name: '',
        template_code: '',
        provider_template_id: '',
        template_type: '验证码短信',
        template_content: ''
      }
      this.parsedVariables = []
      this.addTemplateDialogVisible = true
    },

    // 解析模板变量
    parseTemplateVariables(content) {
      if (!content) {
        this.parsedVariables = []
        return
      }

      const variables = []

      console.log('开始解析模板内容:', content)

      // 方法1：匹配单独的 $$ 占位符
      // 使用更简单的匹配方式
      const dollarMatches = content.match(/\$\$/g)
      console.log('找到的 $$ 数量:', dollarMatches ? dollarMatches.length : 0)

      if (dollarMatches) {
        // 为每个 $$ 生成变量名
        dollarMatches.forEach((match, index) => {
          const varName = index === 0 ? 'code' : `code${index + 1}`
          if (!variables.includes(varName)) {
            variables.push(varName)
            console.log('添加变量:', varName)
          }
        })
      }

      // 方法2：匹配 ${variable} 格式
      const matches1 = content.match(/\$\{(\w+)\}/g)
      if (matches1) {
        matches1.forEach(match => {
          const varName = match.replace(/\$\{(\w+)\}/, '$1')
          if (!variables.includes(varName)) {
            variables.push(varName)
            console.log('添加 ${} 变量:', varName)
          }
        })
      }

      // 方法3：匹配 {variable} 格式  
      const matches2 = content.match(/\{(\w+)\}/g)
      if (matches2) {
        matches2.forEach(match => {
          const varName = match.replace(/\{(\w+)\}/, '$1')
          if (!variables.includes(varName)) {
            variables.push(varName)
            console.log('添加 {} 变量:', varName)
          }
        })
      }

      // 方法4：匹配 {%variable%} 格式
      const matches3 = content.match(/\{%(\w+)%\}/g)
      if (matches3) {
        matches3.forEach(match => {
          const varName = match.replace(/\{%(\w+)%\}/, '$1')
          if (!variables.includes(varName)) {
            variables.push(varName)
            console.log('添加 {%%} 变量:', varName)
          }
        })
      }

      console.log('最终解析到的变量:', variables)
      this.parsedVariables = variables
      return variables
    },
    // 处理新增签名
    async handleAddSign() {
      this.$refs.signForm.validate(async (valid) => {
        if (!valid) return

        this.addingSign = true
        try {
          const requestData = {
            action: 'add_sign',
            store_id: this.userInfo.id,
            account_id: this.currentAccount.id,
            sign_name: this.signForm.sign_name,
            notes: this.signForm.notes
          }

          // 如果有服务商签名ID，添加到请求数据
          if (this.signForm.provider_sign_id) {
            requestData.provider_sign_id = this.signForm.provider_sign_id
          }

          const { data } = await axios.post(
            `${config.BASE_URL}/shop/api/sms_account.php`,
            requestData
          )

          if (data.success) {
            this.$message.success('签名添加成功')
            this.addSignDialogVisible = false
            // 刷新签名列表
            await this.fetchSigns(this.currentAccount.id)
          } else {
            this.$message.error(data.error || '签名添加失败')
          }
        } catch (error) {
          const errorMsg = error.response?.data?.error || error.message || '签名添加失败'
          this.$message.error(`签名添加失败: ${errorMsg}`)
          console.error('添加签名错误:', error)
        } finally {
          this.addingSign = false
        }
      })
    },

    // 处理新增模板
    async handleAddTemplate() {
      this.$refs.templateForm.validate(async (valid) => {
        if (!valid) return

        // 确保在提交前解析变量
        this.parseTemplateVariables(this.templateForm.template_content)

        this.addingTemplate = true
        try {
          const requestData = {
            action: 'add_template',
            store_id: this.userInfo.id,
            account_id: this.currentAccount.id,
            template_name: this.templateForm.template_name,
            template_content: this.templateForm.template_content,
            template_type: this.templateForm.template_type,
            // 保存解析的变量
            template_variables: JSON.stringify(this.parsedVariables)
          }

          console.log('提交的模板数据:', requestData)

          // 添加可选字段
          if (this.templateForm.template_code) {
            requestData.template_code = this.templateForm.template_code
          }
          if (this.templateForm.provider_template_id) {
            requestData.provider_template_id = this.templateForm.provider_template_id
          }

          const { data } = await axios.post(
            `${config.BASE_URL}/shop/api/sms_account.php`,
            requestData
          )

          if (data.success) {
            this.$message.success('模板添加成功')
            this.addTemplateDialogVisible = false
            // 刷新模板列表
            await this.fetchTemplates(this.currentAccount.id)
          } else {
            this.$message.error(data.error || '模板添加失败')
          }
        } catch (error) {
          const errorMsg = error.response?.data?.error || error.message || '模板添加失败'
          this.$message.error(`模板添加失败: ${errorMsg}`)
          console.error('添加模板错误:', error)
        } finally {
          this.addingTemplate = false
        }
      })
    },

    // 删除签名
    async handleDeleteSign(signId) {
      this.$confirm('确定要删除该签名吗？', '警告', {
        confirmButtonText: '确认删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const { data } = await axios.post(
            `${config.BASE_URL}/shop/api/sms_account.php`,
            {
              action: 'delete_sign',
              store_id: this.userInfo.id,
              sign_id: signId
            }
          )

          if (data.success) {
            this.$message.success('签名删除成功')
            // 刷新签名列表
            await this.fetchSigns(this.currentAccount.id)
          } else {
            this.$message.error(data.error || '签名删除失败')
          }
        } catch (error) {
          const errorMsg = error.response?.data?.error || error.message || '签名删除失败'
          this.$message.error(`签名删除失败: ${errorMsg}`)
          console.error('删除签名错误:', error)
        }
      }).catch(() => { })
    },

    // 删除模板
    async handleDeleteTemplate(templateId) {
      this.$confirm('确定要删除该模板吗？', '警告', {
        confirmButtonText: '确认删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const { data } = await axios.post(
            `${config.BASE_URL}/shop/api/sms_account.php`,
            {
              action: 'delete_template',
              store_id: this.userInfo.id,
              template_id: templateId
            }
          )

          if (data.success) {
            this.$message.success('模板删除成功')
            // 刷新模板列表
            await this.fetchTemplates(this.currentAccount.id)
          } else {
            this.$message.error(data.error || '模板删除失败')
          }
        } catch (error) {
          const errorMsg = error.response?.data?.error || error.message || '模板删除失败'
          this.$message.error(`模板删除失败: ${errorMsg}`)
          console.error('删除模板错误:', error)
        }
      }).catch(() => { })
    },

    // 获取签名列表
    async fetchSigns(accountId) {
      this.signsLoading = true
      try {
        const { data } = await axios.post(
          `${config.BASE_URL}/shop/api/sms_account.php`,
          {
            action: 'get_signs',
            store_id: this.userInfo.id,
            account_id: accountId
          }
        )

        if (data.data) {
          this.signs = data.data
        }
      } catch (error) {
        console.error('获取签名列表错误:', error)
        this.signs = []
      } finally {
        this.signsLoading = false
      }
    },

    // 获取模板列表
    async fetchTemplates(accountId) {
      this.templatesLoading = true
      try {
        const { data } = await axios.post(
          `${config.BASE_URL}/shop/api/sms_account.php`,
          {
            action: 'get_templates',
            store_id: this.userInfo.id,
            account_id: accountId
          }
        )

        if (data.data) {
          this.templates = data.data
        }
      } catch (error) {
        console.error('获取模板列表错误:', error)
        this.templates = []
      } finally {
        this.templatesLoading = false
      }
    },

    // 处理搜索
    handleSearch() {
      this.pagination.page = 1
      this.fetchAccountList()
    },

    // 打开新增对话框
    openAddDialog() {
      this.dialogTitle = '新增账户'
      this.isEditMode = false
      this.accountForm = {
        id: null,
        account_name: '',
        provider: 'aliyun',
        is_enabled: 1,
        aliyun_access_key_id: '',
        aliyun_access_key_secret: '',
        aliyun_endpoint: 'dysmsapi.aliyuncs.com',
        aliyun_region: 'cn-hangzhou',
        tencent_secret_id: '',
        tencent_secret_key: '',
        tencent_app_id: '',
        tencent_region: 'ap-guangzhou',
        zhangjun_username: '',
        zhangjun_password: '',
        zhangjun_endpoint: 'http://47.106.170.137:8001/sms',
        feige_api_key: '',
        feige_secret: '',
        feige_endpoint: 'https://api.4321.sh',
        notes: ''
      }
      this.dialogVisible = true
    },

    // 打开编辑对话框
    // 打开编辑对话框
    openEditDialog(row) {
      this.dialogTitle = '编辑账户'
      this.isEditMode = true
      // 深拷贝行数据，避免直接修改
      this.accountForm = JSON.parse(JSON.stringify(row))
      this.dialogVisible = true
    },

    // 打开详情对话框
    openDetailDialog(row) {
      this.currentAccount = row
      this.detailDialogVisible = true
    },

    // 打开同步对话框
    openSyncDialog(row) {
      this.currentAccount = row
      this.syncDialogTitle = `同步数据 - ${row.account_name}`
      this.syncDialogVisible = true
      this.syncResult = null
    },

    // 打开测试对话框
    async openTestDialog(row) {
      this.currentAccount = row
      this.testForm = {
        test_type: 'template',
        template_id: null,
        sign_name: '', // 初始化签名
        template_variables: {},
        content: '',
        phone_number: ''
      }
      this.selectedTemplate = null
      this.templateVariables = []
      this.previewContent = ''

      // 同时加载签名和模板列表
      await Promise.all([
        this.fetchSigns(row.id),
        this.fetchTemplates(row.id)
      ])

      this.testDialogVisible = true
    },

    // 打开测试记录对话框
    openRecordDialog(row) {
      this.currentAccountId = row.id
      this.recordDialogVisible = true
    },

    // 服务商变更处理
    handleProviderChange(provider) {
      // 可以在这里根据服务商调整表单验证规则
      console.log('服务商变更为:', provider)
    },

    // 测试类型变更处理
    handleTestTypeChange() {
      this.testForm.template_id = null
      this.testForm.template_variables = {}
      this.testForm.content = ''
      this.previewContent = ''
    },

    // 模板变更处理
    handleTemplateChange(templateId) {
      console.log('选择的模板ID:', templateId)
      this.selectedTemplate = this.templates.find(t => t.id === templateId)
      console.log('选中的模板:', this.selectedTemplate)

      if (this.selectedTemplate) {
        console.log('模板内容:', this.selectedTemplate.template_content)

        // 重置变量
        this.templateVariables = []
        this.testForm.template_variables = {}

        if (this.selectedTemplate.template_variables && this.selectedTemplate.template_variables.length > 0) {
          console.log('使用存储的变量:', this.selectedTemplate.template_variables)
          try {
            const storedVars = JSON.parse(this.selectedTemplate.template_variables)
            if (Array.isArray(storedVars) && storedVars.length > 0) {
              this.templateVariables = storedVars
            } else {
              // 如果存储的变量为空，重新解析
              console.log('存储的变量为空，重新解析模板内容')
              this.templateVariables = this.parseTemplateVariables(this.selectedTemplate.template_content)
            }
          } catch (e) {
            console.log('解析存储变量失败，重新解析模板内容')
            this.templateVariables = this.parseTemplateVariables(this.selectedTemplate.template_content)
          }
        } else {
          console.log('没有存储的变量，重新解析模板内容')
          this.templateVariables = this.parseTemplateVariables(this.selectedTemplate.template_content)
        }

        console.log('最终变量列表:', this.templateVariables)

        // 初始化变量值
        this.testForm.template_variables = {}
        this.templateVariables.forEach(variable => {
          this.testForm.template_variables[variable] = ''
        })

        console.log('初始化后的变量值:', this.testForm.template_variables)
      } else {
        this.templateVariables = []
        this.testForm.template_variables = {}
      }
      this.updatePreviewContent()
    },
    // 更新预览内容
    updatePreviewContent() {
      if (this.testForm.test_type === 'template' && this.selectedTemplate) {
        let content = this.selectedTemplate.template_content
        Object.keys(this.testForm.template_variables).forEach(key => {
          const value = this.testForm.template_variables[key] || `{{${key}}}`
          content = content.replace(new RegExp(`\\$\\{${key}\\}`, 'g'), value)
          content = content.replace(new RegExp(`\\{${key}\\}`, 'g'), value)
          content = content.replace(new RegExp(`\\{%${key}%\\}`, 'g'), value)
        })
        this.previewContent = content
      } else {
        this.previewContent = this.testForm.content
      }
    },

    // 提交账户表单
    submitAccountForm() {
      this.$refs.accountForm.validate(async (valid) => {
        if (valid) {
          try {
            const action = this.isEditMode ? 'update' : 'add'
            const { data } = await axios.post(
              `${config.BASE_URL}/shop/api/sms_account.php`,
              {
                action,
                ...this.accountForm,
                store_id: this.userInfo.id
              }
            )

            if (data.success) {
              this.$message.success(this.isEditMode ? '更新成功' : '添加成功')
              this.dialogVisible = false
              this.fetchAccountList()
            } else {
              this.$message.error(data.error || '操作失败')
            }
          } catch (error) {
            const errorMsg = error.response?.data?.error || error.message || '操作失败'
            this.$message.error(`操作失败: ${errorMsg}`)
            console.error('表单提交错误:', error)
          }
        }
      })
    },

    // 处理状态变更
    async handleStatusChange(row) {
      try {
        const { data } = await axios.post(
          `${config.BASE_URL}/shop/api/sms_account.php`,
          {
            action: 'update',
            id: row.id,
            store_id: this.userInfo.id,
            is_enabled: row.is_enabled
          }
        )

        if (data.success) {
          this.$message.success('状态更新成功')
        } else {
          // 回滚状态
          row.is_enabled = row.is_enabled ? 0 : 1
          this.$message.error(data.error || '状态更新失败')
        }
      } catch (error) {
        // 回滚状态
        row.is_enabled = row.is_enabled ? 0 : 1
        const errorMsg = error.response?.data?.error || error.message || '状态更新失败'
        this.$message.error(`状态更新失败: ${errorMsg}`)
        console.error('状态更新错误:', error)
      }
    },

    // 同步签名
    async handleSyncSigns() {
      this.syncingSigns = true
      try {
        const { data } = await axios.post(
          `${config.BASE_URL}/shop/api/sms_account.php`,
          {
            action: 'sync_signs',
            id: this.currentAccount.id,
            store_id: this.userInfo.id
          }
        )

        if (data.success) {
          this.syncResult = {
            success: true,
            message: '签名同步成功',
            synced_count: data.synced_count
          }
          this.$message.success('签名同步成功')
        } else {
          this.syncResult = {
            success: false,
            message: data.error || '签名同步失败'
          }
          this.$message.error(data.error || '签名同步失败')
        }
      } catch (error) {
        const errorMsg = error.response?.data?.error || error.message || '签名同步失败'
        this.syncResult = {
          success: false,
          message: errorMsg
        }
        this.$message.error(`签名同步失败: ${errorMsg}`)
        console.error('签名同步错误:', error)
      } finally {
        this.syncingSigns = false
      }
    },

    // 同步模板
    async handleSyncTemplates() {
      this.syncingTemplates = true
      try {
        const { data } = await axios.post(
          `${config.BASE_URL}/shop/api/sms_account.php`,
          {
            action: 'sync_templates',
            id: this.currentAccount.id,
            store_id: this.userInfo.id
          }
        )

        if (data.success) {
          this.syncResult = {
            success: true,
            message: '模板同步成功',
            synced_count: data.synced_count
          }
          this.$message.success('模板同步成功')
        } else {
          this.syncResult = {
            success: false,
            message: data.error || '模板同步失败'
          }
          this.$message.error(data.error || '模板同步失败')
        }
      } catch (error) {
        const errorMsg = error.response?.data?.error || error.message || '模板同步失败'
        this.syncResult = {
          success: false,
          message: errorMsg
        }
        this.$message.error(`模板同步失败: ${errorMsg}`)
        console.error('模板同步错误:', error)
      } finally {
        this.syncingTemplates = false
      }
    },


    // 打开飞鸽云状态报告对话框
    openFeigeReportDialog(row) {
      this.currentAccount = row
      this.feigeReportDialogVisible = true
      this.feigeReportData = []
      this.fetchFeigeReport()
    },

    // 打开飞鸽云上行对话框
    openFeigeMoDialog(row) {
      this.currentAccount = row
      this.feigeMoDialogVisible = true
      this.feigeMoData = []
      this.fetchFeigeMo()
    },

    // 获取飞鸽云状态报告
    async fetchFeigeReport() {
      this.feigeReportLoading = true
      try {
        const { data } = await axios.post(
          `${config.BASE_URL}/shop/api/sms_account.php`,
          {
            action: 'get_feige_report',
            store_id: this.userInfo.id,
            id: this.currentAccount.id,
            count: parseInt(this.reportCount)
          }
        )


        if (data.success) {
          this.feigeReportData = data.data || []
          if (this.feigeReportData.length === 0) {
            this.$message.info('暂无状态报告')
          }
        } else {
          this.$message.error(data.error || '获取状态报告失败')
        }
      } catch (error) {
        const errorMsg = error.response?.data?.error || error.message || '获取状态报告失败'
        this.$message.error(`获取状态报告失败: ${errorMsg}`)
        console.error('获取状态报告错误:', error)
      } finally {
        this.feigeReportLoading = false
      }
    },

    // 获取飞鸽云上行信息
    async fetchFeigeMo() {
      this.feigeMoLoading = true
      try {
        const { data } = await axios.post(
          `${config.BASE_URL}/shop/api/sms_account.php`,
          {
            action: 'get_feige_mo',
            store_id: this.userInfo.id,
            id: this.currentAccount.id,
            count: parseInt(this.moCount)
          }
        )

        if (data.success) {
          this.feigeMoData = data.data || []
          if (this.feigeMoData.length === 0) {
            this.$message.info('暂无上行信息')
          }
        } else {
          this.$message.error(data.error || '获取上行信息失败')
        }
      } catch (error) {
        const errorMsg = error.response?.data?.error || error.message || '获取上行信息失败'
        this.$message.error(`获取上行信息失败: ${errorMsg}`)
        console.error('获取上行信息错误:', error)
      } finally {
        this.feigeMoLoading = false
      }
    },

    // 格式化时间戳
    formatTimestamp(timestamp) {
      if (!timestamp) return '-'
      const date = new Date(timestamp * 1000)
      return date.toLocaleString()
    },

    // 获取报告状态标签类型
    getReportStatusTagType(status) {
      if (status === 'DELIVRD') return 'success'
      if (status === 'UNDELIV' || status.startsWith('FG:') || status === 'REJECTD') return 'danger'
      return 'warning'
    },

    // 发送测试短信
    async handleSendTest() {
      if (!this.testForm.phone_number) {
        this.$message.error('请输入手机号码')
        return
      }

      // 飞鸽云特殊验证
      if (this.currentAccount.provider === 'feige') {
        if (this.testForm.test_type === 'template') {
          // 验证签名ID和模板ID是否为数字
          const sign = this.signs.find(s => s.sign_name === this.testForm.sign_name)
          if (sign && sign.provider_sign_id && !isNaN(sign.provider_sign_id)) {
            // 签名ID正确
          } else {
            this.$message.error('飞鸽云签名ID必须是数字格式，请在签名管理中配置正确的签名ID')
            return
          }

          const template = this.templates.find(t => t.id === this.testForm.template_id)
          if (template && template.provider_template_id && !isNaN(template.provider_template_id)) {
            // 模板ID正确
          } else {
            this.$message.error('飞鸽云模板ID必须是数字格式，请在模板管理中配置正确的模板ID')
            return
          }
        }
      }

      if (this.testForm.test_type === 'template') {
        if (!this.testForm.template_id) {
          this.$message.error('请选择模板')
          return
        }
        if (!this.testForm.sign_name) {
          this.$message.error('请选择签名')
          return
        }
      } else {
        if (!this.testForm.content) {
          this.$message.error('请输入短信内容')
          return
        }
      }

      this.sendingTest = true
      try {
        const { data } = await axios.post(
          `${config.BASE_URL}/shop/api/sms_account.php`,
          {
            action: 'test_sms',
            id: this.currentAccount.id,
            store_id: this.userInfo.id,
            ...this.testForm
          }
        )

        if (data.success) {
          this.$message.success('测试短信发送成功')
          this.testDialogVisible = false
        } else {
          this.$message.error(data.error || '测试短信发送失败')
        }
      } catch (error) {
        const errorMsg = error.response?.data?.error || error.message || '测试短信发送失败'
        this.$message.error(`测试短信发送失败: ${errorMsg}`)
        console.error('测试短信发送错误:', error)
      } finally {
        this.sendingTest = false
      }
    },

    // 删除账户
    async handleDelete(id) {
      this.$confirm('确定要删除该短信账户吗？删除后关联的签名和模板也将被删除', '警告', {
        confirmButtonText: '确认删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const { data } = await axios.post(
            `${config.BASE_URL}/shop/api/sms_account.php`,
            {
              action: 'delete',
              id: id,
              store_id: this.userInfo.id
            }
          )

          if (data.success) {
            this.$message.success('删除成功')
            this.fetchAccountList()
          } else {
            this.$message.error(data.error || '删除失败')
          }
        } catch (error) {
          const errorMsg = error.response?.data?.error || error.message || '删除失败'
          this.$message.error(`删除失败: ${errorMsg}`)
          console.error('删除错误:', error)
        }
      }).catch(() => { })
    },

    // 获取服务商显示文本
    getProviderText(provider) {
      const providerMap = {
        'aliyun': '阿里云',
        'tencent': '腾讯云',
        'zhangjun': '掌骏云',
        'feige': '飞鸽云'
      }
      return providerMap[provider] || provider
    },

    // 获取服务商标签类型
    getProviderTagType(provider) {
      const typeMap = {
        'aliyun': 'primary',
        'tencent': 'success',
        'zhangjun': 'warning',
        'feige': 'info'
      }
      return typeMap[provider] || 'info'
    }
  }
}
</script>

<style scoped lang="scss">
.page-container {
  padding: 0px;
}

.settings-form {
  max-width: 95%;
  margin: 0 auto;
  padding: 32px 40px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
}

.page-title {
  font-size: 24px;
  color: #1f2937;
  margin-bottom: 32px;
  font-weight: 600;
  text-align: center;
  letter-spacing: 0.5px;
}

.search-bar {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  padding: 16px;
  background: #f8fafc;
  border-radius: 8px;
}

.pagination-container {
  margin-top: 24px;
  display: flex;
  justify-content: flex-end;
}

.sync-actions {
  display: flex;
  gap: 15px;
  justify-content: center;
  margin-bottom: 20px;
}

.sync-result {
  margin-top: 20px;

  .sync-count {
    margin-top: 10px;
    text-align: center;
    font-weight: bold;
    color: #67c23a;
  }
}

.variable-list {
  .variable-item {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    .variable-name {
      min-width: 80px;
      font-weight: 500;
    }
  }
}

.variable-tags {
  display: flex;
  flex-wrap: wrap;
  margin-top: 8px;
}

/* 表格样式优化 */
.el-table {
  border: 1px solid #ebeef5;
  border-radius: 8px;
  overflow: hidden;

  :deep(.el-table__header) th {
    background-color: #f5f7fa;
    color: #606266;
    font-weight: 600;
  }

  :deep(.el-table__body) tr:hover>td {
    background-color: #f0f7ff !important;
  }
}

/* 操作按钮样式 */
.el-button {
  display: inline-flex;
  align-items: center;

  .el-icon {
    margin-right: 5px;
  }
}

/* 对话框样式优化 */
:deep(.el-dialog) {
  border-radius: 12px;

  .el-dialog__header {
    padding: 20px 24px;
    border-bottom: 1px solid #ebeef5;
    margin-right: 0;

    .el-dialog__title {
      font-weight: 600;
      color: #1f2937;
    }
  }

  .el-dialog__body {
    padding: 24px;
  }

  .el-dialog__footer {
    padding: 16px 24px;
    border-top: 1px solid #ebeef5;
  }
}

/* 表单验证提示样式 */
:deep(.el-form-item__error) {
  font-size: 12px;
  padding-top: 4px;
}

.action-buttons {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.button-row {
  display: flex;
  gap: 8px;
  justify-content: flex-start;
}

.button-row .el-button {
  flex: 1;
  min-width: 0;
}

.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.form-tips {
  font-size: 12px;
  color: #909399;
  margin-top: 4px;
}

.content-preview {
  max-height: 60px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.user-info {
  .user-nickname {
    font-weight: 500;
    margin-bottom: 4px;
  }

  .user-phone {
    color: #909399;
    font-size: 12px;
  }
}
</style>